import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import siteSettings from '../../config/site-settings';
import {Language} from '../../config/language';
import {AuthService} from '../../../core/services/auth.service';

@Component({
  selector: 'app-sh-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  siteSettings = siteSettings;
  language = Language;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
  }

  gotoPortal(): void {
    console.log('clicked');
    const access_token = this.authService.getToken() || '';
    const lang = localStorage.getItem('currentLang') ? localStorage.getItem('currentLang') : 'ru';
    window.location.href = `https://geo-shym.kz/?access_token=${access_token}&lang=${lang}`;
  }
}
